import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import Label from 'components/forms/label'
import ErrorText from 'components/forms/errorMsg'
import StyledInput from 'components/forms/styledInput'
import { TYPOGRAPHY_18 } from 'theme/theme'

const Icon = styled.div`
  margin-left: -30px;
  cursor: pointer;
`

const Text = styled.div`
  ${TYPOGRAPHY_18}

  color: ${props => props.link ? '#0bf' : '#A0A5B3'};
  margin-left: 20px;
  margin-bottom: 10px;

  &:visited,
  &:active,
  &:focus,
  &:focus-within {
    color: ${props => props.link ? '#0bf' : '#A0A5B3'};
  }
`

const PasswordInput = ({ label, name, onChange, onBlur, errors, touched, disabled, value, placeholder, helpText, showForgot }) => {
  const isError = errors && touched
  const [open, setOpen] = useState(false)
  const triggerSwitch = () => setOpen(!open)

  return (
    <div className="mb-20">
      { showForgot ? <div className="flex v-center">
        <Label id={name} label={label} helpText={helpText} />
        <a href="/forgot-password">
          <Text link>
            Forgot Password?
          </Text>
        </a>
      </div>
        : <Label id={name} label={label} helpText={helpText} /> }
      <div className="flex v-center">
        <StyledInput
          id={name}
          data-test={name}
          type={open ? 'text' : 'password'}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          error={isError}
          disabled={disabled} />
        <Icon onClick={triggerSwitch} data-test="show">
          <img src="/s/icons/show-password.svg" alt="Show password" />
        </Icon>
      </div>
      { isError ? <ErrorText>{ errors }</ErrorText> : null }
    </div>
  )
}

export default PasswordInput

PasswordInput.propTypes = {
  name: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.string,
  label: PropTypes.string,
  showForgot: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  errors: PropTypes.string,
  placeholder: PropTypes.string,
  touched: PropTypes.bool,
  helpText: PropTypes.any
}
